import React, { useState, useEffect, useRef } from 'react'
import { Input, Button, InputRef } from 'antd'
import { Hash } from 'lucide-react'
import type { LineItem } from '../../types/ffe'

interface Props {
  item: LineItem
  onUpdate: (updates: Partial<LineItem>) => void
}

export const LineItemSupplierCode: React.FC<Props> = ({ item, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [tempValue, setTempValue] = useState(item.supplierItemCode || '')
  const inputRef = useRef<InputRef>(null)

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isEditing])

  useEffect(() => {
    setTempValue(item.supplierItemCode || '')
  }, [item.supplierItemCode])

  const handleSubmit = () => {
    onUpdate({ supplierItemCode: tempValue })
    setIsEditing(false)
  }

  if (isEditing) {
    return (
      <Input
        ref={inputRef}
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleSubmit}
        placeholder="Enter product reference"
        className="w-[150px]"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit()
          } else if (e.key === 'Escape') {
            setTempValue(item.supplierItemCode || '')
            setIsEditing(false)
          }
        }}
      />
    )
  }

  return (
    <Button
      type="text"
      icon={<Hash className="h-4 w-4 text-gray-400" />}
      className="h-auto py-1 px-2 hover:bg-gray-50"
      onClick={() => setIsEditing(true)}
    >
      <span className="text-gray-600">
        {item.supplierItemCode || (
          <span className="text-gray-400">Add product SKU/name</span>
        )}
      </span>
    </Button>
  )
}
